import './Divider.css';

export type DividerProps = {
  label?: string;
};

export function Divider({ label = 'or' }: DividerProps) {
  return (
    <div className="divider" role="separator" aria-orientation="horizontal">
      <span className="divider__rule" aria-hidden="true" />
      <span className="divider__label">{label}</span>
      <span className="divider__rule" aria-hidden="true" />
    </div>
  );
}
